import { BaseModel } from "@/models/base.model"
import { type IWorkPeriodTemplateActivity } from "@/interfaces/api/work-period-template-activity.interface.ts"
import { type ActivityTypes } from "@/enums/models/activity-types"
import type { Moment } from "moment"

export class WorkPeriodTemplateActivity extends BaseModel implements IWorkPeriodTemplateActivity {
  public static className = "WorkPeriodTemplateActivity" // Used for socket communication.
  public static verboseName = "template-activiteit"

  template: string

  type: ActivityTypes
  timeStart?: Moment | null
  timeEnd?: Moment | null
  description: string

  constructor(activity: IWorkPeriodTemplateActivity) {
    super(activity)

    this.template = activity.template

    this.type = activity.type
    this.timeStart = activity.timeStart
    this.timeEnd = activity.timeEnd
    this.description = activity.description
  }
}
